module.exports = "/virtual-football/img/video/vvb-body-top.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/vvb-body-top.png
// module id = 315
// module chunks = 6